import { render, staticRenderFns } from "./shift.vue?vue&type=template&id=3896c681&scoped=true&lang=pug"
import script from "./shift.vue?vue&type=script&lang=ts"
export * from "./shift.vue?vue&type=script&lang=ts"
import style0 from "./shift.vue?vue&type=style&index=0&id=3896c681&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3896c681",
  null
  
)

export default component.exports